import React, { Fragment, FunctionComponent } from 'react';
import { memberId } from '@trello/session-cookie';
import { useFeatureFlag } from '@trello/feature-flag-client';
import {
  getRouteIdFromPathname,
  isBoardRoute,
  getBoardShortLinkFromPathname,
  isCardRoute,
  getCardShortLinkFromPathname,
} from '@trello/routes';
import { getLocation } from '@trello/router';

import { useBoardRoutePreloaderQuery } from './BoardRoutePreloaderQuery.generated';
import { useCardRoutePreloaderQuery } from './CardRoutePreloaderQuery.generated';
import { isShortLink } from '@trello/shortlinks';

export const RoutePreloader: FunctionComponent = ({ children }) => {
  const isBoardRoutePreloadingEnabled = useFeatureFlag(
    'fep.board_route_preloading',
    false,
  );

  const isCardRoutePreloadingEnabled = useFeatureFlag(
    'fep.card_route_preloading',
    false,
  );

  const { pathname } = getLocation();
  const routeId = getRouteIdFromPathname(pathname);
  const isBoard = isBoardRoute(routeId);
  const isCard = isCardRoute(routeId);

  const boardShortLink = isBoard ? getBoardShortLinkFromPathname(pathname) : '';
  const cardShortLink = isCard ? getCardShortLinkFromPathname(pathname) : '';
  const { loading: boardLoading } = useBoardRoutePreloaderQuery({
    variables: {
      boardId: boardShortLink || '',
      memberId: memberId || '',
    },
    skip:
      !memberId ||
      !isBoard ||
      !isBoardRoutePreloadingEnabled ||
      !boardShortLink ||
      !isShortLink(boardShortLink),
  });

  const { loading: cardLoading } = useCardRoutePreloaderQuery({
    variables: {
      cardId: cardShortLink || '',
      memberId: memberId || '',
    },
    skip:
      !memberId ||
      !isCard ||
      !isCardRoutePreloadingEnabled ||
      !cardShortLink ||
      !isShortLink(cardShortLink),
  });

  return cardLoading || boardLoading ? null : <Fragment>{children}</Fragment>;
};
